export enum DeliveryType {
	PacketaPickup = "PacketaPickup",
	PacketaCourier = "PacketaCourier",
	Personal = "Personal",
}

export const paidDeliveryTypes = [DeliveryType.PacketaPickup, DeliveryType.PacketaCourier];
